import { useContext, useEffect, useState } from 'react';
import AppChoicesContext from '../context/AppChoicesContext';

const useAppChoices = (key, returnDisabledValuesAlso = true) => {
  const appChoices = useContext(AppChoicesContext);

  // This function processes the choices based on the provided key and flag returnDisabledValuesAlso
  const processChoices = () => {
    let processedChoices = key ? appChoices?.find(choice => choice.key === key)?.values : appChoices;

    if (
      key &&
      !returnDisabledValuesAlso &&
      processedChoices[0] &&
      typeof processedChoices[0] === 'object' &&
      processedChoices[0].hasOwnProperty('isEnabled')
    ) {
      processedChoices = processedChoices?.filter(c => c.isEnabled) || [];
    }

    return processedChoices || [];
  };

  return processChoices();
};

export default useAppChoices;
